import { IPromise, IScope } from 'angular'
import { $q } from '../../../ng-compat/imports'

interface PromotionModalOptions {
  defaultTab?: string
}

/**
 * Controller class for the variant picker modal
 *
 * @class PromotionModalController
 */
export class PromotionModalController {
  public readonly close: () => void
  private readonly internalClose: (val: IPromise<any>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<any>) => void,
    public readonly options: PromotionModalOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'
    this.internalClose = close
    this.close = () => this.internalClose($q.reject())

    // Handle escape key
    this.vdEscapeStack.register(this.close)
    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
